import { Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

interface LoginResponse {
  accessToken: string;
  user: { id: number; email: string; name: string; role: string };
}

const TOKEN_KEY = 'mmd_token';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly _token = signal<string | null>(localStorage.getItem(TOKEN_KEY));

  readonly isLoggedIn = computed(() => !!this._token());
  readonly token = this._token.asReadonly();

  constructor(private http: HttpClient, private router: Router) {}

  login(email: string, password: string) {
    return this.http
      .post<LoginResponse>(`${environment.mmdApi}/auth/login`, { email, password })
      .pipe(
        tap((res) => {
          this._token.set(res.accessToken);
          localStorage.setItem(TOKEN_KEY, res.accessToken);
        }),
      );
  }

  logout() {
    this._token.set(null);
    localStorage.removeItem(TOKEN_KEY);
    this.router.navigate(['/']);
  }
}
